const GLOBAL_BANNER_TYPES = {
    SUPPORT_ACCESS_WARNING: 'supportAccessWarning',
    TRIAL: 'trial',
    UNINSTALLED: 'uninstalled',
    MAU_WARNING: 'mauWarning',
    OVER_MAU: 'overMau',
    NONE: 'none',
};

export default GLOBAL_BANNER_TYPES;
